import axios from "axios";
import { API_URL, API_WITH_CREDENTIALS } from "./config";

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: API_WITH_CREDENTIALS, // required for HttpOnly cookie auth
  headers: {
    "Content-Type": "application/json",
  },
});

// Optional: basic response handling hook (expand later)
api.interceptors.response.use(
  (res) => res,
  (err) => Promise.reject(err)
);
